var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLs = function SvgIconLs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M0 12c0 1.87.428 3.64 1.19 5.217L12 17.74l10.81-.522A11.95 11.95 0 0 0 24 12c0-1.87-.428-3.64-1.19-5.217L12 6.26l-10.81.521A11.95 11.95 0 0 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 24a12 12 0 0 0 10.81-6.782H1.191A12 12 0 0 0 12.001 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 0A12 12 0 0 0 1.192 6.781H22.81A12 12 0 0 0 12-.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.783 11.74V8.87h-1.565v2.87l-1.89 1.89a3.128 3.128 0 0 0 5.345 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconLs;